var component = require('../../../lib/js/component.js');
var AdobeLaunch = require('../../../lib/js/adobelaunch.js');
var YoutubeEmbedController = require('../../../lib/js/youtube-embed-controller.js');

function Lightbox() {
    /**
     * Init for the Card module
     * @param  {Object} element HTML element
     */
    this.initialize = function (element) {
        var _this = this,
            $element = $(element),
            $previousElement = $element.prev(),
            $imgPlaceholder = $previousElement.find('.has-lightbox'),
            $youtubeVideo = $element.find('.youtube-video iframe'),
            $videoTour = $element.find('.Lightbox-tour');

        var $saveIcon = $element.find('.save-item');
        var $heartShape = $saveIcon.find("i");

        $saveIcon.on('click', function() {
            //the item is not saved, so after clicking it will be saved, which means aria-current should be true
            if ($heartShape.hasClass("icon-heart")) {
                $saveIcon.attr('aria-current', 'true');
            } else {
                $saveIcon.attr('aria-current', 'false');
            }
        });
        
        var youtubeVideoId = $imgPlaceholder.data('idvideo');
        var $image = $element.find('img');

        _this.embed = null;
        _this.currentVideoId = null;

        // If cinemagraph, add lightbox functionality to the video tag
        if ($previousElement.hasClass('u-responsiveVideo')) {
            var $cinemagraph = $($previousElement[0].previousSibling);
            $cinemagraph.attr('data-toggle', 'modal');
            $cinemagraph.attr('data-target', $previousElement.data('target'));
            $cinemagraph.addClass('has-lightbox');

            if ($previousElement.hasClass('has-lightbox-tablet')) {
                $cinemagraph.addClass('has-lightbox-tablet');
            }
        }

        // Wire up iframe postMessage controller
        var iframe = $youtubeVideo.length ? $youtubeVideo[0] : null;
        if (iframe) {
            _this.currentVideoId = youtubeVideoId;
            _this.embed = YoutubeEmbedController.attach({
                iframe: iframe,
                $container: $element,
                $modalElement: $element,
                videoId: youtubeVideoId
            });

            $element.on('youtube:ended.lightboxAnalytics', function () {
                if (AdobeLaunch && AdobeLaunch.pushVideoStatusChangedEvent) {
                    var $wrapperElement = $(iframe).closest('.Lightbox-video-wrapper, .youtube-video');
                    AdobeLaunch.pushVideoStatusChangedEvent($wrapperElement, AdobeLaunch.VIDEO_STATUS_CHANGED_EVENT_NAME);
                }
            });
        }

        $element.on('show.bs.modal.lightbox', function (event) {
            if ($image && $image.length > 0) {
                setTimeout(function () {
                    if (!$image.hasClass('is-loaded')) {
                        $image.trigger('RESPONSIVE_LAZYLOAD');
                        $image.cloudinary_update();
                        $.cloudinary.responsive();
                    }
                }, 500);
            }

            if ($youtubeVideo.length == 0 && $videoTour.length > 0) {
                var videoTourSrc = $videoTour.attr('src');
                if (!videoTourSrc) {
                    setTimeout(function () {
                        $videoTour.attr('src', $videoTour.data('tour'));
                    }, 500);
                }
            }
        });

        $element.on('hide.bs.modal.lightbox', function () {
            if (_this.embed) {
                _this.embed.stopVideo();
            }

            if ($videoTour.length > 0) {
                $videoTour.attr('src', '');
            }
        });
    };
}

module.exports = component(Lightbox);
